<script setup>
import { computed } from "vue";
const { type, customClass } = defineProps({
  type: {
    type: String,
    default: "submit",
  },
  customClass: {
    type: String,
    default: "",
  },
});

const buttonClass = computed(() => {
  return `inline-flex items-center px-4 py-2 bg-gray-800  border border-transparent rounded-md font-semibold text-md text-white  uppercase tracking-widest hover:bg-gray-700  focus:bg-gray-700  active:bg-gray-900  focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2  transition ease-in-out duration-150 ${customClass}`;
});
</script>

<template>
  <button :type="type" :class="buttonClass">
    <slot />
  </button>
</template>
